import {Pipe, PipeTransform} from '@angular/core';
import {EformService} from "../../service/eform.service";

@Pipe({name: 'radio'})
export class RadioPipe implements PipeTransform {

   constructor(private eformService: EformService) {
   }

   transform(choice: number, stringIndex: number): string {
   return this.swithContent(this.declareChoiceString(choice),
                             stringIndex);
   }

   declareChoiceString(choice: number) {
      return this.eformService.storeChoiceString(choice);
   }

   swithContent(content, indexString: number) {
      const x  = content.split('/');
      return indexString === 0 ? x[0] : x[1];
   }
}
